var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEffeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 142.663,
    height: 54.803,
    viewBox: "0 0 142.663 54.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_639",
    "data-name": "Rettangolo 639",
    width: 142.663,
    height: 54.803,
    fill: "#0e120e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1746",
    "data-name": "Raggruppa 1746",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2754",
    "data-name": "Tracciato 2754",
    d: "M90.429,24.191h8.659l1.737-7.376h-10.4Z",
    transform: "translate(5.191 0.965)",
    fill: "#0e120e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1745",
    "data-name": "Raggruppa 1745",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1744",
    "data-name": "Raggruppa 1744",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2755",
    "data-name": "Tracciato 2755",
    d: "M90.009,0c-8,0-13.147,5.287-13.147,13.444v4.109H62.256v8.375H76.862V53.7h9.774V13.368h.024C86.84,9.534,89.685,8.6,91.78,8.6a10.931,10.931,0,0,1,3.087.367V.738A14.3,14.3,0,0,0,90.009,0",
    transform: "translate(3.574 0)",
    fill: "#0e120e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2756",
    "data-name": "Tracciato 2756",
    d: "M62.713,0C54.7,0,49.56,5.29,49.56,13.447v4.109H38.627L37.01,25.931H49.56V53.7h9.771V13.368h.026C59.54,9.534,62.385,8.6,64.47,8.6a10.935,10.935,0,0,1,3.087.367V.738A14.218,14.218,0,0,0,62.713,0",
    transform: "translate(2.125 0)",
    fill: "#0e120e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2757",
    "data-name": "Tracciato 2757",
    d: "M17.927,23.5c5.584,0,7.931,3.525,8.082,7.125H9.844A7.825,7.825,0,0,1,17.927,23.5m8.534,17.69c-1.327,2.6-3.74,4.346-7.726,4.346a8.8,8.8,0,0,1-9.113-8.227H35.489c0-.147.147-1.618.147-3.011,0-11.606-6.687-18.732-17.855-18.732C8.523,15.565,0,23.058,0,34.59,0,46.784,8.743,53.91,18.663,53.91c8.2,0,13.7-4.441,15.95-10.027Z",
    transform: "translate(0 0.893)",
    fill: "#0e120e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2758",
    "data-name": "Tracciato 2758",
    d: "M119.149,23.5c5.586,0,7.931,3.525,8.086,7.125H111.062a7.825,7.825,0,0,1,8.087-7.125m8.684,17.341c-1.292,2.787-3.72,4.692-7.871,4.692a8.8,8.8,0,0,1-9.115-8.227H136.71c0-.147.143-1.618.143-3.011,0-11.6-6.686-18.729-17.848-18.729-9.259,0-17.783,7.493-17.783,19.024,0,12.2,8.744,19.321,18.66,19.321,8.375,0,13.948-4.625,16.1-10.375Z",
    transform: "translate(5.811 0.893)",
    fill: "#0e120e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEffeLogo);
export default __webpack_public_path__ + "static/media/effe-logo.4bfacec43b12481493da39b38e315feb.svg";
export { ForwardRef as ReactComponent };